<template>
  <div class="waggon-wrapper">
    <div
      class="waggon color-3"
      :style="`${zoom
        ?
          `border-radius: calc(4px * ${zoom}) !important;
          margin: calc(2px * ${zoom});
          width: calc((var(--workpackage_width) + 4px) * ${zoom} * ${duration ? duration : 1});
          height: calc((var(--workpackage_height) + 4px) * ${zoom});`
        :
          `${duration
            ?
              `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom) * ${duration} +
              ${duration > 1
                ?
                  `(2px * var(--taktplan_zoom) * 2 * ${duration - 1})`
                :
                  '0px'});`
            :
              ''}`
      }
      ${dummy
        ?
          `border: solid calc(2px * var(--taktplan_zoom)) var(--v-color-3-base);
          background-color: var(--v-color-1-base) !important;`
        :
          ''
      }
      ${$store.state.View.show_taktplan_shadows
        ?
          `box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);`
        :
          ''}
      `"
    >
      <div class="waggon-prepend">
        <slot name="prepend"/>
      </div>
      <div class="waggon-grid" :style="`grid-template-columns: ${gridColumns}`">
        <slot name="content" :waggon="waggon" :easter_egg="easter_egg"/>
      </div>
      <div class="waggon-append">
        <slot name="append"/>
      </div>
      <div class="waggon-badge">
        <slot name="badge"/>
      </div>
    </div>
    <slot name ="waggon-steps"/>
  </div>
</template>

<script>
export default {
  name: 'waggon',
  props: ['workpackage_count', 'waggon', 'zoom', 'dummy', 'easter_egg', 'duration'],
  data: () => ({
  }),
  updated() {
  },
  computed: {
    gridColumns: function() {
      if (this.workpackage_count) {
        let column_count = 2
        if (this.workpackage_count !== 2) {
          column_count = Math.ceil(this.workpackage_count/2)
        }
        return `repeat(${column_count}, ${100/column_count}%)`
      } else {
        return 'repeat(1, 100%)'
      }
    },
  }
}
</script>
<style lang="css">
  .waggon {
    border-radius: calc(4px * var(--taktplan_zoom)) !important;
    margin: calc(2px * var(--taktplan_zoom));
    width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom));
    will-change: width, height;
    transition: none;

    /* v-card css */
    border-width: thin;
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    transition-property: box-shadow,opacity;
    overflow-wrap: break-word;
    position: relative;
    white-space: normal;
  }
  .waggon-grid {
    display: grid;
  }
  .waggon-prepend {
    position: absolute;
    top: 50%;
    left: -2px;
  }
  .waggon-append {
    position: absolute;
    top: 50%;
    right: -2px;
  }
  .waggon-badge {
    position: absolute;
    left: calc(100% - (15px * var(--taktplan_zoom)));
    top: calc(-4px * var(--taktplan_zoom));
    z-index: 10;
  }
  .waggon-wrapper {
    display: flex;
  }
</style>
